import React, { Fragment, useState } from "react";

// react query
import { useDeleteUser, useListUser } from "../../hooks/useAccounting";

// components
import Loading from "../../components/Loadings/LoadingTable";
import { Table } from "../../components/Table/Table";
import AddNewUserDialog from "../../components/Dialog/AddNewUserDialog";

// styled components
import { Container } from "../../theme/GlobalStyle";

// data
import { personalInfo } from "../../data/accountingMenu";
import Button from "../../components/Button/Button";
import { useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import { idPersonAtom } from "../../shared/factor";
import BreadCrumb from "../../components/BreadCrumb/BreadCrumb";
import { separate } from "../../utils/separate";

const WrapperBtn = ({ toggleShowModal, setUpdatedUser }) => {
  return (
    <div style={{ margin: "1rem" }}>
      <Button
        small
        bgColor="#0D6EFD"
        color="#fff"
        size="14px"
        onclick={() => {
          toggleShowModal();
          setUpdatedUser({});
        }}
      >
        درج شخص جدید
      </Button>
    </div>
  );
};

const PersonalInfo = ({
  addInvoice,
  setForm,
  form,
  setUser,
  toggleHideModal,
  CrmUsers,
  reports,
  textBtn,
}) => {
  // navigate
  const navigate = useNavigate();

  const [, setIdPerson] = useRecoilState(idPersonAtom);

  // page Number
  const [PageNumber, setPageNumber] = useState(1);
  // sort
  const [isSort, setIsSort] = useState({
    name: false,
    row: false,
    phone: false,
  });
  //   search
  const [Search, setSearch] = useState("");
  //   sort by status
  const [Status, setStatus] = useState("");
  // update user
  const [updatedUser, setUpdatedUser] = useState({});

  // modal for creating and updating user
  const [isShow, setIsShow] = useState(false);

  //   query client
  const queryClient = useQueryClient();

  //   handle change status
  const handleChange = (e) => setStatus(e.target.value);

  //   header title
  const headerTitle = CrmUsers
    ? ["ردیف", "نام و نام خانوادگی ^", "شماره تلفن", "حذف"]
    : reports
    ? [
        "ردیف",
        "نام و نام خانوادگی ^",
        "شماره تلفن",
        "مانده",
        "تاریخ اخرین بازدید",
        "ماهیت فعلی",
        "گردش حساب",
      ]
    : [
        "ردیف",
        "نام و نام خانوادگی ^",
        "شماره تلفن",
        "مانده",
        "تاریخ اخرین بازدید",
        "ماهیت فعلی",
        "ویرایش",
        "حذف",
        "گردش حساب",
      ];

  const headerTitle1 = ["#", "نام و نام خانوادگی", "شماره تلفن", "انتخاب "];

  // react query getching all user
  const { data, isPreviousData } = useListUser({
    PageNumber: !Search ? PageNumber : 1,
    Search,
    Status,
  });
  const listUser = data?.data?.users;
  const AllUsers = data?.data?.AllUsers;

  // delete user
  const { mutateAsync: deleteUser } = useDeleteUser();

  // handle next page
  const handleNext = () => {
    setPageNumber((prevState) => prevState + 1);
  };

  // handle previos page
  const handlePrevios = () => {
    if (PageNumber === 1) {
      setPageNumber(1);
    } else {
      setPageNumber((prevState) => prevState - 1);
    }
  };

  const handleDeleteUser = async (id) => {
    await deleteUser(id);
    queryClient.invalidateQueries("list-user", PageNumber);
  };

  const sortNames = () => {
    if (isSort.name === true) {
      return listUser?.sort((a, b) => (a?.FirstName < b?.FirstName ? -1 : 1));
    } else if (isSort.row === true) {
      return listUser?.sort((a, b) => a?.IdUser - b?.IdUser);
    } else if (isSort.row === false) {
      return listUser?.sort((a, b) => b?.IdUser - a?.IdUser);
    } else if (isSort.phone === true) {
      return listUser?.sort((a, b) => a?.Phone - b?.Phone);
    } else if (isSort.phone === false) {
      return listUser?.sort((a, b) => b?.Phone - a?.Phone);
    } else {
      return listUser?.sort((a, b) => (a?.FirstName > b?.FirstName ? -1 : 1));
    }
  };

  const items = sortNames() ? (
    sortNames()?.map((item, index) => {
      return (
        <tr key={item?.IdUser} className="item-table">
          {addInvoice ? (
            <>
              <td>
                <span className="text-muted fw-bold text-muted d-block fs-7">
                  {index + 1}
                </span>
              </td>
              <td>
                <span className="text-muted fw-bold text-muted d-block fs-7">
                  {`${item.FirstName} ${item.LastName}`}
                </span>
              </td>
              <td>
                <span className="text-muted fw-bold text-muted d-block fs-7">
                  {item.Phone}
                </span>
              </td>
              <td>
                <Button
                  bgColor="#0062FF"
                  small="100px"
                  color="#fff"
                  onclick={() => {
                    setForm({
                      ...form,
                      IdUserOrderOffline: item?.IdUser,
                      IdEquivalentOrderOffline: "",
                    });

                    setUser(item);
                    setIdPerson(item.IdUser);
                    toggleHideModal();
                  }}
                >
                  {textBtn ? textBtn : "انتخاب"}
                </Button>
              </td>
            </>
          ) : (
            <>
              <td>
                <span className="text-muted fw-bold text-muted d-block fs-7">
                  {index + 1}
                </span>
              </td>
              <td>
                <span className="text-muted fw-bold text-muted d-block fs-7">
                  {`${item.FirstName || ""} ${item.LastName || ""}`}
                </span>
              </td>
              <td>
                <span className="text-muted fw-bold text-muted d-block fs-7">
                  {`0${item.Phone}`}
                </span>
              </td>
              {!CrmUsers ? (
                <>
                  <td>
                    <span className="text-muted fw-bold text-muted d-block fs-7">
                      {separate(item?.AmountOfFirstPeriod)}
                    </span>
                  </td>
                  <td>
                    <span className="text-muted fw-bold text-muted d-block fs-7">
                      {item?.ExistenceOfFirstPeriod}
                    </span>
                  </td>
                  <td>
                    <span className="text-muted fw-bold text-muted d-block fs-7">
                      {item?.ExistenceOfFirstPeriod}
                    </span>
                  </td>

                  {!reports ? (
                    <td>
                      <Button
                        size="12px"
                        bgColor="#0D6EFD"
                        small="100px"
                        color="#fff"
                        onclick={() => {
                          setIsShow(true);
                          setUpdatedUser(item);
                        }}
                      >
                        ویرایش
                      </Button>
                    </td>
                  ) : null}
                </>
              ) : null}
              {!reports ? (
                <td>
                  <Button
                    size="12px"
                    bgColor="#DC3545"
                    small="100px"
                    color="#fff"
                    onclick={() => handleDeleteUser(item?.IdUser)}
                  >
                    حذف
                  </Button>
                </td>
              ) : null}
              {!CrmUsers ? (
                <td>
                  <Button
                    size="12px"
                    bgColor="#DC3545"
                    small="100px"
                    color="#fff"
                    onclick={() =>
                      navigate(
                        `/dashboard/accounting/baseInfo/personInfo/${item?.IdUser}`
                      )
                    }
                  >
                    گردش حساب
                  </Button>
                </td>
              ) : null}
            </>
          )}
        </tr>
      );
    })
  ) : (
    <Loading />
  );

  return (
    <Fragment>
      <BreadCrumb
        margin="mt-3"
        num1="واحد حسابداری"
        num2="اطلاعات پایه"
        num3="اطلاعات اشخاص"
      />

      <Container>
        <Table
          setSearch={setSearch}
          title={`لیست اشخاص (${AllUsers})`}
          headerTitle={addInvoice ? headerTitle1 : headerTitle}
          setIsSort={setIsSort}
          isSort={isSort}
          items={items}
          setPageNumber={setPageNumber}
          PageNumber={PageNumber}
          sortItems={personalInfo}
          handleChange={handleChange}
          sort="true"
          countPage={AllUsers}
          scroll
          isPreviousData={isPreviousData}
          handleNext={handleNext}
          handlePrevios={handlePrevios}
          paginate
          detailOrder={
            !CrmUsers && !reports ? (
              <WrapperBtn
                toggleShowModal={() => setIsShow(true)}
                isToggle={isShow}
                setUpdatedUser={setUpdatedUser}
              />
            ) : null
          }
          CrmUsers={CrmUsers}
          //   countPage={count}
        />
      </Container>
      {isShow && (
        <AddNewUserDialog
          isToggle={isShow}
          toggleHideModal={() => setIsShow(false)}
          PageNumber={PageNumber}
          updatedUser={updatedUser}
        />
      )}
    </Fragment>
  );
};

export default PersonalInfo;
